import { Icon } from '@chakra-ui/react';

export default function SFArchiveFilled(props) {
  return (
    <Icon
      width={4}
      height='15px'
      viewBox='0 0 16 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M1.51562 3.6875C0.632812 3.6875 0.1875 3.16406 0.1875 2.28906V1.57812C0.1875 0.703125 0.679688 0.179688 1.51562 0.179688H14.4766C15.3594 0.179688 15.8047 0.703125 15.8047 1.57812V2.28906C15.8047 3.16406 15.3594 3.6875 14.4766 3.6875H1.51562ZM3.71094 14.5625C2.17188 14.5625 1.35156 13.7734 1.35156 12.2344V4.75781H14.6406V12.2344C14.6406 13.7656 13.8203 14.5625 12.2812 14.5625H3.71094ZM5.42188 7.57812H10.5781C10.9062 7.57812 11.1406 7.35156 11.1406 7.00781V6.76562C11.1406 6.42188 10.9062 6.20312 10.5781 6.20312H5.42188C5.09375 6.20312 4.86719 6.42188 4.86719 6.76562V7.00781C4.86719 7.35156 5.09375 7.57812 5.42188 7.57812Z' />
    </Icon>
  );
}
